import type { ConfirmarSimulacaoDialogProps } from "./types-confirmar-simulacao-dialog";
import { useConfirmarSimulacaoDialog } from "./use-confirmar-simulacao-dialog";
import { ConfirmarSimulacaoDialogView } from "./view-confirmar-simulacao-dialog";

/**
 * Confirmação destrutiva do Modo Simulação (Descartar com alterações pendentes e Desfazer,
 * HU 2221). O X fecha preservando o cenário, como o cancelar.
 */
export function ConfirmarSimulacaoDialog(props: ConfirmarSimulacaoDialogProps) {
  const vm = useConfirmarSimulacaoDialog(props);

  return <ConfirmarSimulacaoDialogView {...vm} />;
}

export type * from "./types-confirmar-simulacao-dialog";
